import React from 'react';
import PropTypes from 'prop-types';
import DateField from '@/pages/_post-opportunity/_fields/DateField.v2';

DateRangeField.propTypes = {
  value: PropTypes.string,
  label: PropTypes.node,
  placeholder: PropTypes.string,
  description: PropTypes.node,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.node,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  onStartDateChange: PropTypes.func,
  onEndDateChange: PropTypes.func,
};

DateRangeField.defaultProps = {
  disabled: false
};

export default function DateRangeField(props) {
  const {
    label,
    description,
    error,
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange
  } = props;

  return (
    <div>
      {label ? (
        <label className="text-base font-semibold text-cs-gray-900">
          {label}
        </label>
      ): null}
      <div className="flex items-center">
        <div className="flex-1">
          <DateField
            date={startDate}
            onChange={onStartDateChange}
          />
        </div>
        <div className="px-4 text-cs-gray-900">to</div>
        <div className="flex-1">
          <DateField
            date={endDate}
            onChange={onEndDateChange}
          />
        </div>
      </div>
      {error ? (
        <div className="mt-1 text-sm text-red-600">
          {error}
        </div>
      ) : null}
      {description ? (
        <small className="text-sm text-cs-gray-500">
          {description}
        </small>
      ) : null}
    </div>
  );
}
